import React, { Component } from "react";
import { Link } from "react-router-dom";
import Page from "../2/Controls/Page";
import PageSection from "../2/Controls/PageSection";
import Input from "../2/Controls/Input";
import axios from "axios";
import _ from "lodash";
import Window from "../2/Controls/Window";
import Dropzone from "react-dropzone";
// import Button from "../2/Controls/Button";

const BaseURL = "https://backend-197598313260.asia-south1.run.app";

class InTransit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      searchTerm: "",
      inTransitList: [],
      selectedItems: [],
      selectedTransaction: null,
      errorMessages: {},
      saved: false,
      searchFocused: false,
      showSaveErrors: false,
      showPutAwayConfirmation: false,
      transactionDetails: null,
      userId: this.props.user.user.key,
      statusFilter: "all", // New state for status filter
      searchTermToteNo: "",
      images: [],
      showPopup: false,
      popupBarcodeError: "",
      poupupDamageError: "",
      popupBarcode: "",
      damaged: false,
      issueFilter: "all",
      selectedItem: null,
      showApproveRejectScreen: false,
      approvalStatus: "",
    };
    this.itemRefs = {};
    this.onDrop = this.onDrop.bind(this);
    this.onRemoveImage = this.onRemoveImage.bind(this);
    this.saveLineItemApproveReject = this.saveLineItemApproveReject.bind(this);
    this.onConfirmReInward = this.onConfirmReInward.bind(this);

    // this.autoSaveDebounce = _.debounce(this.autoSaveItem, 1000);
  }

  componentDidMount() {
    const { key } = this.props.match.params;
    if (key) {
      this.loadInTransitData(key);
    }
  }

  async checkbarcode(barcode, gid) {
    try {
      // console.log("barcode", barcode);
      // console.log("gid", gid);
      const response = await axios.get(
        BaseURL + "/v1/check-barcode-by-gid/" + barcode + "/" + gid,
        {
          params: {},
        }
      );
      // console.log("response.data", response.data);
      const data = response.data;
      // console.log(data);
      if (data.match) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error loading data:", error);
      // this.setState({ loading: false });
      return;
    }
  }

  async loadInTransitData(id) {
    this.setState({ loading: true });
    try {
      let registrationID = this.props.user.user.RegistrationID;
      let storeID = this.props.user.store.key;
      const { state } = this.props.location;
      if (state && state.verification) {
        // console.log("Verification is true");
        registrationID = state.RegistrationID;
        storeID = state.StoreID;
      }
      const response = await axios.get(`${BaseURL}/v1/vendorStockInward`, {
        params: {
          docId: id,
          registrationID: registrationID,
          storeID: storeID,
        },
      });
      const data = response.data.data;
      console.log("data", data);
      const inTransitList = [];
      for (let i = 0; i < data.Lineitems.length; i++) {
        let item = data.Lineitems[i];
        inTransitList.push({
          index: i,
          key: item._id,
          Name: item.ProductName,
          SKU: item.SKU,
          BarCode: item.Barcode,
          Image: item.Images && item.Images.length > 0 ? item.Images[0] : "",
          MRP: item.MRP,
          SupplierPrice: item.SupplyPrice,
          InvoiceQty: item.InvoiceQty,
          // InwardQty: item.Status === "Not Received" ? 0 : item.InwardQty || 0,
          InwardQty: item.InwardQty || 0,
          DamageQty: item.DamagedQty || 0,
          // ShortQty: item.Status === "Not Received" ? item.InvoiceQty : item.ShortQty || 0,
          ShortQty: item.ShortQty || 0,
          GID: item.GID,
          Expiry: item.Expiry,
          PackageDetails: item.PackageDetails || [],
          PackageID: item.PackageID || "",
          Status: item.Status || "Not Received",
          _id: item._id,
          GRNNO: item.GRNNO ? item.GRNNO : "",
          DNNO: item.DNNO ? item.DNNO : "",
          IssueImages: item.IssueImages ? item.IssueImages : [],
          DamageReason: item.DamageReason ? item.DamageReason : "",
          WrongProductValue: item.WrongProductValue
            ? item.WrongProductValue
            : "",
          ApprovalStatus: item.ApprovalStatus ? item.ApprovalStatus : "",
          DamageRaisedQty: item.DamageRaisedQty ? item.DamageRaisedQty : "",
          ShortRaisedQty: item.ShortRaisedQty ? item.ShortRaisedQty : 0,
          ShortApprovedQty: item.ShortApprovedQty ? item.ShortApprovedQty : 0,
          ShortRejectedQty: item.ShortRejectedQty ? item.ShortRejectedQty : 0,
          ShortRejectedQtyAction: item.ShortRejectionReason
            ? item.ShortRejectionReason
            : "",
          DamageApprovedQty: item.DamageApprovedQty
            ? item.DamageApprovedQty
            : 0,
          DamageRejectedQty: item.DamageRejectedQty
            ? item.DamageRejectedQty
            : 0,
          DamageRejectedQtyAction: item.DamageRejectionReason
            ? item.DamageRejectionReason
            : "",
          ReturnToWh: item.ReturnToWh,
          ReInwardQty: item.ReInwardQty ? item.ReInwardQty : 0,
        });
      }

      this.setState({
        inTransitList,
        transactionDetails: data,
        loading: false,
        approvalStatus: data.ApprovalStatus ? data.ApprovalStatus : "",
        issueFilter: data.Status === "Re Inward" ? "reinward" : "",
      });
    } catch (error) {
      console.error("Error loading data:", error);
      this.setState({ loading: false });
    }
  }

  onDrop(acceptedFiles, rejectedFiles) {
    if (acceptedFiles.length > 0) {
      if (acceptedFiles.length + this.state.images.length > 2) {
        alert("Max no images uploaded");
        return;
      }
      if (acceptedFiles[0].size / 1024 > 500) {
        alert("File size should not be more than 500 KB");
        return;
      }
      this.setState({ imageLoading: true });

      let fileName = +new Date().getTime() + acceptedFiles[0].name;
      this.props
        .uploadFileToServer(
          acceptedFiles[0],
          this.props.registration.registration.StorageFolder + "/whdamage",
          fileName
        )
        .then((downloadURL) => {
          //update product with images url
          let bucket = "posible.in/";
          let folder =
            this.props.registration.registration.StorageFolder + "/whdamage/";
          let url =
            "https://storage.googleapis.com/" + bucket + folder + fileName;
          let image = {
            ImageName: fileName,
            ImageSize: acceptedFiles[0].size,
            ImagePath: url,
          };
          // {ImagePath:imagePath, ImageName: imageName, ImageSize: imageSize }
          let imagesToBeUploaded = this.state.images;
          imagesToBeUploaded.push(image);
          this.setState({
            images: imagesToBeUploaded,
            imageLoading: false,
            poupupDamageError: "",
          });
        });
    } else {
      alert("No file selected");
    }
  }

  onRemoveImage(index) {
    let array = [...this.state.images];
    array.splice(index, 1);
    this.setState({ images: array });
  }

  handleSearch = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  handleSearchTote = (e) => {
    this.setState({ searchTermToteNo: e.target.value });
  };

  getFilteredItems() {
    const {
      searchTerm,
      inTransitList,
      statusFilter,
      searchTermToteNo,
      issueFilter,
    } = this.state;
    let filteredItems = inTransitList;

    // Apply status filter first
    if (statusFilter !== "all") {
      filteredItems = filteredItems.filter((item) => {
        switch (statusFilter) {
          case "pending":
            return item.Status === "Pending";
          case "done":
            return item.Status === "Put away - Done";
          case "not_received":
            return item.Status === "Not Received";
          default:
            return true;
        }
      });
    }

    if (searchTerm !== "" || searchTermToteNo !== "") {
      filteredItems = filteredItems.filter((item) => {
        const matchesTote =
          searchTermToteNo === "" ||
          item.PackageID.toLowerCase().includes(searchTermToteNo.toLowerCase());

        const matchesSearch =
          searchTerm === "" ||
          item.Name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.SKU.toLowerCase().includes(searchTerm.toLowerCase()) ||
          // item.BarCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (item.BarCode &&
            (Array.isArray(item.BarCode)
              ? item.BarCode.some(
                  (b) => b && b.toLowerCase().includes(searchTerm.toLowerCase())
                )
              : item.BarCode.toLowerCase().includes(searchTerm.toLowerCase()))) ||
          item.GID.toLowerCase().includes(searchTerm.toLowerCase());

        // if both are entered, both must match;
        // if one is empty, the empty condition automatically passes
        return matchesTote && matchesSearch;
      });
    }

    if (issueFilter === "issue") {
      filteredItems = filteredItems.filter((item) => {
        if (item.ShortQty > 0 || item.DamageQty > 0) {
          return true;
        }
      });
    }
    if (issueFilter === "reinward") {
      filteredItems = filteredItems.filter((item) => {
        if (item.ReInwardQty > 0) {
          return true;
        }
      });
    }
    return filteredItems;
  }

  calculateTotals(inTransitList) {
    return inTransitList.reduce(
      (acc, item) => {
        return {
          invoiceQty: acc.invoiceQty + (item.InvoiceQty || 0),
          inwardQty: acc.inwardQty + (item.InwardQty || 0),
          shortQty: acc.shortQty + (item.ShortQty || 0),
          damageQty: acc.damageQty + (item.DamageQty || 0),
          reInwardQty:
            Number(acc.reInwardQty) +
            (item.ReInwardQty ? Number(item.ReInwardQty) : 0),
          // DamageQty total removed
        };
      },
      { invoiceQty: 0, inwardQty: 0, shortQty: 0, damageQty: 0, reInwardQty: 0 }
    );
  }

  validateAllFields() {
    const { inTransitList } = this.state;
    const errors = {};
    let hasErrors = false;

    inTransitList.forEach((item, index) => {
      if (item.Status === "Put away - Done" || item.Status === "Not received") {
        return;
      }

      const itemErrors = {};
      const total =
        (item.InwardQty || 0) + (item.DamageQty || 0) + (item.ShortQty || 0);

      if (total > item.InvoiceQty) {
        itemErrors.quantities = `Total quantities (${total}) cannot exceed Invoice Qty (${item.InvoiceQty})`;
        hasErrors = true;
      }

      if (Object.keys(itemErrors).length > 0) {
        errors[index] = itemErrors;
      }
    });

    this.setState({ errorMessages: errors });
    return !hasErrors;
  }

  handleQtyChange = (key, index, field, value) => {
    const item = this.state.inTransitList[index];
    if (item.Status === "Put away - Done" || item.Status === "Not received") {
      return;
    }

    const newValue = value === "" ? "" : parseInt(value) || 0;
    const updatedList = [...this.state.inTransitList];
    const currentItem = updatedList[index];

    if (field === "ShortQty") {
      // When ShortQty changes, calculate ReceivedQty
      updatedList[index] = {
        ...currentItem,
        [field]: newValue,
        InwardQty: Math.max(
          0,
          currentItem.InvoiceQty - (currentItem.DamageQty || 0) - newValue
        ),
      };
    } else if (field === "InwardQty") {
      // When ReceivedQty changes, calculate ShortQty
      updatedList[index] = {
        ...currentItem,
        [field]: newValue,
        ShortQty: Math.max(
          0,
          currentItem.InvoiceQty - (currentItem.DamageQty || 0) - newValue
        ),
      };
    } else if (field === "DamageQty") {
      // When ReceivedQty changes, calculate ShortQty
      updatedList[index] = {
        ...currentItem,
        [field]: newValue,
        InwardQty: Math.max(
          0,
          currentItem.InvoiceQty - (currentItem.ShortQty || 0) - newValue
        ),
      };
    } else {
      // For other fields (like DamageQty, though it's hidden)
      updatedList[index] = {
        ...currentItem,
        [field]: newValue,
      };

      // Recalculate both ReceivedQty and ShortQty when DamageQty changes
      // const remainingQty = currentItem.InvoiceQty - newValue;
      // updatedList[index].InwardQty = Math.max(
      //   0,
      //   remainingQty - (currentItem.ShortQty || 0)
      // );
      // updatedList[index].ShortQty = Math.max(
      //   0,
      //   remainingQty - (currentItem.InwardQty || 0)
      // );
    }

    const updatedErrors = { ...this.state.errorMessages };
    const total =
      updatedList[index].InwardQty +
      updatedList[index].DamageQty +
      updatedList[index].ShortQty;

    if (total > currentItem.InvoiceQty) {
      updatedErrors[index] = {
        ...updatedErrors[index],
        quantities: `Total quantities (${total}) cannot exceed Invoice Qty (${currentItem.InvoiceQty})`,
      };
    } else {
      if (updatedErrors[index] && updatedErrors[index].quantities) {
        delete updatedErrors[index].quantities;
        if (Object.keys(updatedErrors[index]).length === 0) {
          delete updatedErrors[index];
        }
      }
    }

    this.setState({
      inTransitList: updatedList,
      errorMessages: updatedErrors,
    });
  };

  handleErrorClick = (index) => {
    if (this.itemRefs[index]) {
      this.itemRefs[index].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  showPutAwayDialog = (key, index) => {
    const { inTransitList } = this.state;
    let item = inTransitList[index];

    //check if barcode exists or not
    let barcodeDoesNotExists = false;
    if (item.InwardQty > 0) {
      // barcodeDoesNotExists =
      //   item.BarCode && item.BarCode.trim() !== "" ? false : true;
      barcodeDoesNotExists = Array.isArray(item.BarCode)
        ? item.BarCode.length === 0 || item.BarCode.every((b) => !b || b.trim() === "")
        : item.BarCode && item.BarCode.trim() !== ""
        ? false
        : true;
    }

    let damaged = Number(item.DamageQty) > 0 ? true : false;
    // console.log("barcodeDoesNotExists", barcodeDoesNotExists);
    // console.log("damaged", damaged);
    // barcodeDoesNotExists = true;

    //if all qty is short
    if (Number(item.InvoiceQty) === Number(item.ShortQty)) {
      this.setState({
        showPutAwayConfirmation: true,
        selectedItemIndex: index,
      });
      return;
    }
    if (barcodeDoesNotExists || damaged) {
      this.setState({
        selectedItemIndex: index,
        showPopup: true,
        barcodeDoesNotExists: barcodeDoesNotExists,
        damaged: damaged,
      });
    } else {
      this.setState({
        showPutAwayConfirmation: true,
        selectedItemIndex: index,
      });
    }
  };

  async saveLineItemApproveReject(selectedItem) {
    const { userId } = this.state;
    this.setState({ saving: true });
    const key = this.props.match.params.key;

    //     ReInwardStatus - Pending/Completed/GRN Done
    // ReInwardQty
    // ReInwardGRN;

    // console.log("selectedItem", selectedItem);
    let obj = {
      _id: selectedItem._id,
      ShortRaisedQty: selectedItem.ShortQty,
      ShortApprovedQty: selectedItem.ShortApprovedQty,
      ShortRejectedQty: selectedItem.ShortRejectedQty,
      ShortRejectionReason: selectedItem.ShortRejectedQtyAction,
      DamageRaisedQty: selectedItem.DamageQty,
      DamageApprovedQty: selectedItem.DamageApprovedQty,
      DamageRejectedQty: selectedItem.DamageRejectedQty,
      DamageRejectionReason: selectedItem.DamageRejectedQtyAction
        ? selectedItem.DamageRejectedQtyAction
        : "",
      ReturnToWh: selectedItem.ReturnToWh ? selectedItem.ReturnToWh : false,
      ApprovalStatus: "Completed",
    };

    let reinwardQty = 0;
    if (selectedItem.ShortRejectedQtyAction === "INWARD_BY_MERCHANT") {
      reinwardQty = Number(selectedItem.ShortRejectedQty);
    }
    if (selectedItem.DamageRejectedQtyAction === "INWARD_BY_MERCHANT") {
      reinwardQty += Number(selectedItem.DamageRejectedQty);
    }
    if (reinwardQty > 0) {
      obj.ReInwardStatus = "Pending";
      obj.ReInwardQty = reinwardQty;
      obj.ReInwardGRN = "";
    }
    const payload = {
      lineItemUpdates: [obj],
      userId,
      registrationID: this.state.transactionDetails.RegistrationID,
      storeID: this.state.transactionDetails.StoreID,
    };

    console.log("payload", JSON.stringify(payload));
    // return;
    const res = await axios.put(
      `${BaseURL}/v1/vendorstockinward/lineitem/${key}`,
      payload
    );
    console.log("res", res);
    ///reload data post save
    await this.loadInTransitData(key);

    this.setState({
      selectedItem: null,
      selectedItemIndex: -1,
      showApproveRejectScreen: false,
      saving: false,
    });
  }

  async onConfirmReInward() {
    if (
      window.confirm("Please ensure put away is done for all re-inward items. ")
    ) {
      const res = await axios.get(
        `${BaseURL}/v1/vendorstockinward/confirm-re-inward/${this.props.match.params.key}`
      );
      if (res && res.data && res.data.code && res.data.code === "0") {
        alert("Data saved successfully");
        this.loadInTransitData(this.props.match.params.key);
        return;
      } else {
        alert("Error saving data.");
      }
    }
  }

  confirmPutAway = async () => {
    const { inTransitList, userId, selectedItemIndex } = this.state;
    const key = this.props.match.params.key;

    try {
      if (selectedItemIndex < 0) {
        alert("Invalid record selected");
        return;
      }
      let item = inTransitList[selectedItemIndex];
      if (
        Number(item.InvoiceQty) !==
        Number(
          Number(item.InwardQty) +
            Number(item.DamageQty) +
            Number(item.ShortQty)
        )
      ) {
        alert(
          "Sum total of Inward Qty, Damaged Qty and Short Qty is NOT EQAUL to Shipped Qty."
        );
        return;
      }
      // console.log("item", item);
      // let barcode = item.BarCode ? item.BarCode.trim() : "";
      let barcode = Array.isArray(item.BarCode)
        ? (item.BarCode[0] || "").trim()
        : item.BarCode
        ? item.BarCode.trim()
        : "";
      let popupBarcode = this.state.popupBarcode;
      let barcodeDoesNotExists = this.state.barcodeDoesNotExists;
      let damageReason = this.state.damageReason;
      let wrongProductValue = this.state.wrongProductValue;

      let images = [];
      this.state.images.map((i) => images.push(i.ImagePath));

      const payload = {
        lineItemUpdates: [
          {
            _id: item._id,
            Status: "Put away - Done",
            InwardQty: item.InwardQty,
            DamagedQty: item.DamageQty,
            ShortQty: item.ShortQty,
            Barcode: barcode,
            IssueImages: images,
            DamageReason: damageReason,
            WrongProductValue: wrongProductValue,
          },
        ],
        userId,
        registrationID: this.props.user.user.RegistrationID,
        storeID: this.props.user.store.key,
      };
      // console.log("payload", payload)
      if (
        barcode.trim() === "" &&
        barcodeDoesNotExists &&
        popupBarcode &&
        popupBarcode.trim() !== ""
      ) {
        // barcode = popupBarcode.trim();
        let validBarcode = await this.checkbarcode(
          popupBarcode.trim(),
          item.SKU
        );
        if (validBarcode) {
          payload.lineItemUpdates[0].Barcode = popupBarcode.trim();
        } else {
          this.setState({
            popupBarcodeError:
              "Barcode is not mapped to " +
              item.SKU +
              " in smart catalogue. Pls contact central team.",
          });
          return;
        }
      }

      if (Number(item.DamageQty) > 0 && images.length > 0) {
        // images = this.state.images;
        payload.lineItemUpdates[0].IssueImages = images;
      }
      //check if barcode

      // console.log("payload", JSON.stringify(payload));

      const res = await axios.put(
        `${BaseURL}/v1/vendorstockinward/lineitem/${key}`,
        payload
      );
      this.setState({
        // inTransitList: updatedList,
        selectedItems: [],
        // transactionDetails: res.data.data,
        showPutAwayConfirmation: false,
        saved: true,
        selectedItemIndex: -1,
        images: [],
        barcodeDoesNotExists: false,
        damaged: false,
        popupBarcode: "",
        poupupDamageError: "",
        showPopup: false,
      });

      //this.setState({ });
      setTimeout(() => this.setState({ saved: false }), 3000);
      this.loadInTransitData(key);
    } catch (error) {
      console.error("Error updating status:", error);
      this.loadInTransitData(key);
      alert("Error updating status. Please try again.");
    }
  };

  cancelPutAway = () => {
    this.setState({ showPutAwayConfirmation: false, selectedItemIndex: -1 });
  };

  async onApprovalSave() {
    //check if all
    let items = this.state.inTransitList;
    let allApproved = true;
    items.map((m) => {
      if ((m.ShortQty > 0 || m.DamageQty > 0) && m.ApprovalStatus === "") {
        allApproved = false;
      }
    });

    if (!allApproved) {
      alert(
        "Please approve or reject all short or damage line items before saving"
      );
      return;
    }

    if (
      window.confirm(
        "Are you sure you wish to save this record. Post saving you will not be able to make any changes"
      )
    ) {
      const key = this.props.match.params.key;
      const res = await axios.get(
        `${BaseURL}/v1/vendorstockinward/approvalstatus/${key}`,
        {}
      );
      console.log("res", res);
      if (res && res.data && res.data.code && res.data.code === "0") {
        alert("Data saved successfully");
        this.loadInTransitData(key);
        return;
      } else {
        alert("Error saving data.");
      }
      // https://backend-197598313260.asia-south1.run.app/v1/vendorstockinward/approvalstatus/68e6a89eef2817d1c572b37c
    }
    //save
  }

  renderImage = (imageUrl, altText) => {
    const defaultImage =
      "https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png";
    const imgStyle = {
      width: "40px",
      height: "40px",
      objectFit: "cover",
      borderRadius: "4px",
      marginTop: "-21px",
    };

    return (
      <img
        src={imageUrl || defaultImage}
        alt={altText}
        style={imgStyle}
        onError={(e) => {
          e.target.src = defaultImage;
          e.target.onerror = null;
        }}
      />
    );
  };

  formatExpiryDate = (isoString) => {
    const date = new Date(isoString);

    // options: show day + month name + year
    const options = { day: "2-digit", month: "long", year: "numeric" };

    return date.toLocaleDateString("en-GB", options);
  };

  renderTransactionDetails() {
    const { transactionDetails } = this.state;
    if (!transactionDetails) return null;

    return (
      <div
        style={{
          backgroundColor: "#f8f9fa",
          padding: "15px",
          borderRadius: "5px",
          marginBottom: "20px",
          display: "flex",
          flexWrap: "wrap",
          gap: "20px",
        }}
      >
        <div style={{ minWidth: "200px", flex: 1 }}>
          {/* <h6 style={{ marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px' }}>Invoice Details</h6> */}
          <div style={{ marginBottom: "5px" }}>
            <strong>SO No:</strong> {transactionDetails.SONo || "N/A"}
          </div>
          <div style={{ marginBottom: "5px" }}>
            <strong>Invoice No:</strong> {transactionDetails.SINo || "N/A"}
          </div>
          <div style={{ marginBottom: "5px" }}>
            <strong>Invoice Date:</strong>{" "}
            {transactionDetails.CreatedDate
              ? new Date(transactionDetails.CreatedDate).toLocaleDateString()
              : "N/A"}
          </div>
          <div style={{ marginBottom: "5px" }}>
            <strong>Invoice Amount:</strong>{" "}
            {transactionDetails.SIAmount || "0"}
          </div>
          <div style={{ marginBottom: "5px" }}>
            <strong>Invoice Qty:</strong> {transactionDetails.SIQty || "0"}
          </div>
        </div>
        <div style={{ minWidth: "200px", flex: 1 }}>
          {/* <h6 style={{ marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px' }}>Vendor Details</h6> */}
          <div style={{ marginBottom: "5px" }}>
            <strong>From:</strong>{" "}
            {transactionDetails.VendorName
              ? transactionDetails.VendorName
              : "N/A"}
          </div>
          <div style={{ marginBottom: "5px" }}>
            <strong>Address:</strong>{" "}
            {transactionDetails.Address ? transactionDetails.Address : "N/A"}
          </div>
        </div>

        <div style={{ minWidth: "200px", flex: 1 }}>
          {/* <h6 style={{ marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px' }}>Status & Timing</h6> */}
          <div
            style={{
              marginBottom: "5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {/* <strong style={{ marginRight: '5px' }}>Status:</strong> */}
            <span
              style={{
                backgroundColor:
                  transactionDetails.Status === "Put away - Pending"
                    ? "#9fa728ff"
                    : "#28a745",
                color: "white",
                // padding: '3px 8px',
                // borderRadius: '4px',
                // fontSize: '12px'
                display: "inline-block",
                padding: "4px 10px",
                borderRadius: "12px",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              {transactionDetails.Status || "N/A"}
            </span>
          </div>

          <div style={{ marginBottom: "5px" }}>
            <strong>Receiving Time:</strong>{" "}
            {transactionDetails.ReceivingTime
              ? new Date(transactionDetails.ReceivingTime).toLocaleString()
              : "N/A"}
          </div>
          <div style={{ marginBottom: "5px" }}>
            <strong>Completed Time:</strong>{" "}
            {transactionDetails.CompletedTime
              ? new Date(transactionDetails.CompletedTime).toLocaleString()
              : "N/A"}
          </div>
        </div>
      </div>
    );
  }

  renderItems() {
    const filteredItems = this.getFilteredItems();
    const totals = this.calculateTotals(filteredItems);
    const hasErrors =
      this.state.showSaveErrors &&
      Object.keys(this.state.errorMessages).length > 0;
    const { transactionDetails } = this.state;
    const hidePutawayAndImport =
      transactionDetails && transactionDetails.Status === "Completed";

    return (
      <div className="viewsales-table-container">
        {hasErrors && (
          <div
            style={{
              backgroundColor: "#f8d7da",
              color: "#721c24",
              padding: "10px",
              borderRadius: "4px",
              marginBottom: "15px",
              border: "1px solid #f5c6cb",
            }}
          >
            <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
              <i className="fa fa-exclamation-triangle mr-2"></i>
              Please fix the following errors:
            </div>
            {Object.entries(this.state.errorMessages).map(([index, error]) => (
              <div
                key={index}
                style={{ cursor: "pointer", marginTop: "5px" }}
                onClick={() => this.handleErrorClick(index)}
              >
                <i className="fa fa-arrow-right mr-2"></i>
                Row {parseInt(index) + 1}: {error.quantities}
              </div>
            ))}
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search by SKU or Product Name"
                value={this.state.searchTerm}
                onChange={this.handleSearch}
                style={{
                  borderRadius: "20px",
                  padding: "10px 20px 10px 35px",
                  width: "300px",
                }}
              />
              <i
                className="fa fa-search"
                style={{
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#6c757d",
                }}
              ></i>
            </div>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search by Tote No"
                value={this.state.searchTermToteNo}
                onChange={this.handleSearchTote}
                style={{
                  borderRadius: "20px",
                  padding: "10px 20px 10px 35px",
                  width: "300px",
                }}
              />
              <i
                className="fa fa-search"
                style={{
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#6c757d",
                }}
              ></i>
            </div>
            {/* Add Status Filter Dropdown */}
            <div
              className="form-group"
              style={{ marginBottom: 0, minWidth: "200px" }}
            >
              <select
                className="form-control"
                value={this.state.statusFilter}
                onChange={(e) =>
                  this.setState({ statusFilter: e.target.value })
                }
              >
                <option value="all">All Statuses</option>
                <option value="pending">Pending</option>
                <option value="done">Put away - Done</option>
                <option value="not_received">Not received</option>
              </select>
            </div>
            <div
              className="form-group"
              style={{ marginBottom: 0, minWidth: "200px" }}
            >
              <select
                className="form-control"
                value={this.state.issueFilter}
                onChange={(e) => this.setState({ issueFilter: e.target.value })}
              >
                <option value="all">All</option>
                <option value="issue">Damage/Wrong/Short Qty</option>
                {this.state.transactionDetails &&
                  this.state.transactionDetails.Status === "Re Inward" && (
                    <option value="reinward">Re Inward Items</option>
                  )}
              </select>
            </div>
            {/* {!hidePutawayAndImport && (
              <button
                className="btn btn-warning"
                onClick={this.showPutAwayDialog}
                style={{
                  color: "white",
                  borderRadius: "20px",
                  padding: "10px 20px",
                  height: "40px",
                }}
              >
                <i className="fa fa-check-circle mr-2"></i> Put Away Done
              </button>
            )} */}
          </div>

          <div style={{ display: "flex", gap: "10px" }}>
            <label
              className="btn btn-outline-primary mb-0"
              onClick={this.exportData}
              style={{ cursor: "pointer" }}
            >
              <i className="fa fa-download mr-2"></i> Export
            </label>
          </div>
        </div>

        <table
          className="table table-striped table-bordered"
          style={{ tableLayout: "fixed" }}
        >
          <thead>
            <tr>
              <th style={{ width: "3%" }}>Sr No</th>
              <th style={{ width: "22%" }}>Product</th>
              <th style={{ width: "10%" }}>Tote No</th>
              <th style={{ width: "10%" }}>Shipped Qty</th>
              <th style={{ width: "10%" }}>Received Qty</th>
              <th style={{ width: "10%" }}>Damage/Wrong Qty</th>
              <th style={{ width: "10%" }}>Short Qty</th>
              {this.state.transactionDetails &&
                this.state.transactionDetails.Status === "Re Inward" && (
                  <th style={{ width: "10%" }}>Re Inward Qty</th>
                )}

              <th style={{ width: "10%" }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredItems.map((item, index) => {
              const error =
                this.state.errorMessages[index] &&
                this.state.errorMessages[index].quantities
                  ? this.state.errorMessages[index].quantities
                  : "";
              const isLocked =
                item.Status === "Put away - Done" ||
                item.Status.trim().toLowerCase() === "not received";

              const isSelected = this.state.selectedItems.includes(item.key);

              return (
                <React.Fragment key={index}>
                  <tr
                    style={{
                      height: "60px",
                      backgroundColor: isLocked ? "#f0f0f0" : "inherit",
                      opacity: isLocked ? 0.8 : 1,
                    }}
                    ref={(el) => (this.itemRefs[index] = el)}
                  >
                    <td>{index + 1}</td>
                    <td>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {this.renderImage(item.Image, item.Name)}
                        <div style={{ marginLeft: "30px" }}>
                          <strong>{item.Name}</strong>
                          <div style={{ fontSize: "12px", color: "#060a0eff" }}>
                            WH SKU: {item.GID}
                          </div>
                          {item.BarCode !== "" && (
                            <div
                              style={{ fontSize: "12px", color: "#060a0eff" }}
                            >
                              Barcode: {item.BarCode}
                            </div>
                          )}
                          <div style={{ fontSize: "12px", color: "#060a0eff" }}>
                            MRP: {item.MRP}
                          </div>
                          <div style={{ fontSize: "12px", color: "#060a0eff" }}>
                            Expiry: {this.formatExpiryDate(item.Expiry)}
                          </div>

                          {item.GRNNO && (
                            <div
                              style={{ fontSize: "12px", color: "#060a0eff" }}
                            >
                              GRN No: {item.GRNNO}
                            </div>
                          )}

                          {item.DNNO && (
                            <div
                              style={{ fontSize: "12px", color: "#060a0eff" }}
                            >
                              DN No: {item.DNNO}
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                    <td>{item.PackageID}</td>
                    <td>{item.InvoiceQty}</td>
                    <td>
                      <Input
                        type="number"
                        value={item.InwardQty}
                        min="0"
                        max={item.InvoiceQty}
                        onChange={(value) =>
                          this.handleQtyChange(
                            item.key,
                            item.index,
                            "InwardQty",
                            value
                          )
                        }
                        disabled={isLocked}
                      />
                    </td>
                    <td>
                      <Input
                        type="number"
                        value={item.DamageQty}
                        min="0"
                        max={item.InvoiceQty}
                        onChange={(value) =>
                          this.handleQtyChange(
                            item.key,
                            item.index,
                            "DamageQty",
                            value
                          )
                        }
                        disabled={isLocked}
                      />
                      {item.Status !== "Pending" &&
                        item.IssueImages &&
                        item.IssueImages.length > 0 && (
                          <a
                            onClick={() => {
                              console.log("item", item);
                              this.setState({
                                showViewPoup: true,
                                images: item.IssueImages,
                                damageReason: item.DamageReason
                                  ? item.DamageReason
                                  : "",
                                wrongProductValue: item.WrongProductValue
                                  ? item.WrongProductValue
                                  : "",
                              });
                            }}
                          >
                            View Damaged
                          </a>
                        )}
                      {item.ApprovalStatus === "Completed" &&
                        item.DamageRaisedQty > 0 && (
                          <>
                            <table className="table table-striped table-bordered">
                              <thead>
                                <tr>
                                  <th></th>
                                  <th>Qty</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Raised</td>
                                  <td>{item.DamageRaisedQty}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <div>Approved</div>
                                    {item.DamageApprovedQty > 0 && (
                                      <div
                                        style={{
                                          fontSize: "12px",
                                          fontStyle: "italic",
                                        }}
                                      >
                                        Return to WH:{" "}
                                        {item.ReturnToWh ? "Yes" : "No"}
                                      </div>
                                    )}
                                  </td>
                                  <td>{item.DamageApprovedQty}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <div>Rejected</div>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        fontStyle: "italic",
                                      }}
                                    >
                                      {/* {item.DamageRejectedQtyAction} */}
                                      {item.DamageRejectedQtyAction ===
                                      "INWARD_BY_MERCHANT"
                                        ? "To be re inwarded by merchant"
                                        : ""}
                                    </div>
                                  </td>
                                  <td>{item.DamageRejectedQty}</td>
                                </tr>
                              </tbody>
                            </table>
                          </>
                        )}
                    </td>
                    <td>
                      <Input
                        type="number"
                        value={item.ShortQty}
                        min="0"
                        max={item.InvoiceQty}
                        onChange={(value) =>
                          this.handleQtyChange(
                            item.key,
                            item.index,
                            "ShortQty",
                            value
                          )
                        }
                        disabled={isLocked}
                      />
                      {item.ApprovalStatus === "Completed" &&
                        item.ShortRaisedQty > 0 && (
                          <>
                            {/* <div>Approved Qty: {item.ShortApprovedQty}</div>
                            <div>Rejected Qty: {item.ShortRejectedQty}</div>
                            <div>
                              Rejection Action: {item.ShortRejectedQtyAction}
                            </div> */}

                            <table className="table table-striped table-bordered">
                              <thead>
                                <tr>
                                  <th></th>
                                  <th>Qty</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Raised</td>
                                  <td>{item.ShortRaisedQty}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <div>Approved</div>
                                  </td>
                                  <td>{item.ShortApprovedQty}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <div>Rejected</div>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        fontStyle: "italic",
                                      }}
                                    >
                                      {item.ShortRejectedQtyAction ===
                                      "INWARD_BY_MERCHANT"
                                        ? "To be re inwarded by merchant"
                                        : ""}
                                    </div>
                                  </td>
                                  <td>{item.ShortRejectedQty}</td>
                                </tr>
                              </tbody>
                            </table>
                          </>
                        )}
                    </td>
                    {this.state.transactionDetails &&
                      this.state.transactionDetails.Status === "Re Inward" && (
                        <td>
                          <Input
                            type="number"
                            value={item.ReInwardQty}
                            min="0"
                            disabled={isLocked}
                          />
                        </td>
                      )}

                    <td>
                      {item.Status === "Pending" && (
                        <button
                          className="btn btn-warning"
                          onClick={() =>
                            this.showPutAwayDialog(item.key, item.index)
                          }
                          style={{
                            color: "white",
                            // borderRadius: "20px",
                            // padding: "10px 20px",
                            // height: "40px",
                          }}
                        >
                          <i className="fa fa-check-circle mr-2"></i> Put Away
                          Done
                        </button>
                      )}
                      <span
                        style={{
                          display: "inline-block",
                          padding: "4px 10px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          fontWeight: "bold",
                          color:
                            item.Status === "Put away - Done"
                              ? "white"
                              : item.Status === "Not Received"
                              ? "white"
                              : "white",
                          backgroundColor:
                            item.Status === "Put away - Done"
                              ? "#28a745"
                              : item.Status === "Not Received"
                              ? "#dc3545"
                              : "#9fa728ff",
                          border:
                            item.Status === "Put away - Done"
                              ? "1px solid #c3e6cb"
                              : item.Status === "Not Received"
                              ? "1px solid #f5c6cb"
                              : "1px solid #e9ecef",
                        }}
                      >
                        {item.Status}
                        {item.Status === "Put away - Done" && (
                          <i
                            className="fa fa-lock ml-2"
                            style={{ fontSize: "14px" }}
                          ></i>
                        )}
                      </span>
                      {this.props.location &&
                        this.props.location.state &&
                        this.props.location.state.verification &&
                        this.state.approvalStatus === "" &&
                        (item.ShortQty > 0 || item.DamageQty > 0) && (
                          <>
                            <br />
                            <br />
                            <a
                              onClick={() => {
                                let msg = "Are you sure you wish to approve ";
                                if (item.ShortQty > 0) {
                                  msg += item.ShortQty + " Short Qty";
                                }
                                if (item.DamageQty > 0) {
                                  msg += item.DamageQty + " Damage Qty";
                                }
                                if (window.confirm(msg)) {
                                  // alert("approved");
                                  let selectedItem = { ...item };
                                  selectedItem.ShortApprovedQty =
                                    selectedItem.ShortQty;
                                  selectedItem.ShortRejectedQty = 0;
                                  selectedItem.ShortRejectedQtyAction = "";
                                  selectedItem.DamageApprovedQty =
                                    selectedItem.DamageQty;
                                  selectedItem.DamageRejectedQty = 0;
                                  selectedItem.DamageRejectedQtyAction = "";
                                  this.saveLineItemApproveReject(selectedItem);
                                }
                              }}
                            >
                              Approve
                            </a>
                            <br />
                            <br />
                            <a
                              onClick={() => {
                                this.setState({
                                  showApproveRejectScreen: true,
                                  selectedItemIndex: item.index,
                                  selectedItem: { ...item },
                                });
                              }}
                            >
                              Reject
                            </a>
                          </>
                        )}
                    </td>
                  </tr>
                  {error && this.state.showSaveErrors && (
                    <tr>
                      <td colSpan="9" style={{ color: "red", padding: "10px" }}>
                        <div
                          onClick={() => this.handleErrorClick(index)}
                          style={{ cursor: "pointer", display: "inline-block" }}
                        >
                          <i className="fa fa-exclamation-circle mr-2"></i>
                          {error}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
            <tr style={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>
              <td colSpan="3" style={{ textAlign: "right" }}>
                Totals:
              </td>
              <td>{totals.invoiceQty}</td>
              <td>{totals.inwardQty}</td>
              <td>{totals.damageQty}</td>
              <td>{totals.shortQty}</td>
              {this.state.transactionDetails &&
                this.state.transactionDetails.Status === "Re Inward" && (
                  <td>{totals.reInwardQty}</td>
                )}
              <td>{""}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  renderFooter() {
    const { errorMessages, saved, transactionDetails } = this.state;
    const hasErrors =
      this.state.showSaveErrors && Object.keys(errorMessages).length > 0;
    const hidePutawayAndImport =
      transactionDetails && transactionDetails.Status === "Completed";
    return (
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "#f8f9fa",
          padding: "15px",
          borderTop: "1px solid #dee2e6",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "0 auto",
          }}
        >
          <div style={{ flex: 1 }}>
            {saved && (
              <div
                style={{
                  color: "#28a745",
                  backgroundColor: "#d4edda",
                  borderColor: "#c3e6cb",
                  padding: "10px",
                  borderRadius: "4px",
                  display: "inline-block",
                }}
              >
                <i className="fa fa-check-circle mr-2"></i>
                Product changes saved successfully!
              </div>
            )}
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <button
              type="button"
              className="btn btn-flat btn-default"
              onClick={() => {
                const { state } = this.props.location;
                if (state && state.verification) {
                  this.props.history.push({
                    pathname: "/home/pincode/whinboundverification",
                  });
                } else {
                  this.props.history.push({
                    pathname: "/home/inventory/whinbound",
                  });
                }
              }}
            >
              <i className="fa fa-arrow-left mr-2"></i> Back
            </button>
            {this.props.location &&
              this.props.location.state &&
              this.props.location.state.verification &&
              this.state.approvalStatus === "" && (
                <button
                  type="button"
                  className="btn btn-flat btn-success pull-right"
                  onClick={() => this.onApprovalSave(false)}
                >
                  Save
                </button>
              )}
            {transactionDetails && transactionDetails.Status === "Re Inward" && (
              <button
                type="button"
                className="btn btn-flat btn-success pull-right"
                onClick={() => this.onConfirmReInward(false)}
              >
                Confirm Re Inward Done
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderPoup() {
    return (
      <>
        {this.state.showPopup && (
          <Window
            header="Additonal Info"
            width={"400px"}
            modal={true}
            processing={this.state.saving}
            onClose={() => {
              if (
                this.state.images.length > 0 ||
                this.state.popupBarcode.trim() !== ""
              ) {
                if (
                  window.confirm(
                    "Changes will be lost. Are you sure you want to close the window?"
                  )
                ) {
                  this.setState({
                    showPopup: false,
                    selectedItemIndex: -1,
                    damaged: false,
                    barcodeDoesNotExists: false,
                    popupBarcode: "",
                    popupBarcodeError: "",
                    images: [],
                    poupupDamageError: "",
                    damageReason: "",
                    wrongProductValue: "",
                    wrongProductValueError: "",
                  });
                }
              }
            }}
            onButtonClick={(buttonType) => {
              if (buttonType.toLowerCase() === "save") {
                let popupBarcodeError = "";
                let poupupDamageError = "";
                let wrongProductValueError = "";

                if (
                  this.state.barcodeDoesNotExists &&
                  this.state.popupBarcode === ""
                ) {
                  popupBarcodeError = "Please enter product barcode";
                }
                if (this.state.damaged && this.state.images.length === 0) {
                  poupupDamageError = "Please upload damaged product images ";
                }
                if (
                  this.state.damaged &&
                  this.state.damageReason === "wrong barcode" &&
                  this.state.wrongProductValue.trim() === ""
                ) {
                  wrongProductValueError = "Please provide value";
                }

                if (
                  popupBarcodeError !== "" ||
                  poupupDamageError !== "" ||
                  wrongProductValueError !== ""
                ) {
                  this.setState({
                    popupBarcodeError: popupBarcodeError,
                    poupupDamageError: poupupDamageError,
                    wrongProductValueError: wrongProductValueError,
                  });
                  return;
                }

                this.confirmPutAway();
              } else {
                this.setState({
                  showPopup: false,
                  selectedItemIndex: -1,
                  damaged: false,
                  barcodeDoesNotExists: false,
                  damageReason: "",
                  wrongProductValue: "",
                  wrongProductValueError: "",
                  poupupDamageError: "",
                  popupBarcodeError: "",
                });
              }
            }}
            buttons={[
              { Type: "secondary", Text: "Cancel", Align: "left" },
              { Type: "primary", Text: "Save", Align: "right" },
            ]}
          >
            {this.state.barcodeDoesNotExists && (
              <div className="row">
                <div className="col-md-6">
                  <Input
                    label="Please enter product Barcode"
                    error={this.state.popupBarcodeError}
                    type="text"
                    value={this.state.popupBarcode}
                    onChange={(value) =>
                      this.setState({
                        popupBarcode: value,
                        popupBarcodeError: "",
                      })
                    }
                  ></Input>
                </div>
              </div>
            )}
            {this.state.damaged && (
              <>
                <div className="row">
                  <div className="col-md-6">
                    <Input
                      type="select"
                      value={this.state.damageReason}
                      label="Please select appropriate reason"
                      onChange={(value) => {
                        this.setState({
                          damageReason: value,
                          wrongProductValue: "",
                        });
                      }}
                    >
                      <option value="Damaged">Damaged</option>
                      <option value="Wrong product">Wrong product</option>
                      <option value="Wrong barcode">Wrong barcode</option>
                      <option value="wrong mrp">Wrong MRP</option>
                    </Input>
                  </div>
                </div>
                {this.state.damageReason === "wrong barcode" && (
                  <div className="row">
                    <div className="col-md-6">
                      <Input
                        type="number"
                        label="Please enter received product barcode"
                        value={this.state.wrongProductValue}
                        error={this.state.wrongProductValueError}
                        onChange={(value) =>
                          this.setState({
                            wrongProductValue: value,
                            wrongProductValueError: "",
                          })
                        }
                      />
                    </div>
                  </div>
                )}
                <div className="row">
                  <div className="col-md-6">
                    <Dropzone onDrop={(files) => this.onDrop(files)}>
                      <div>
                        Try dropping some files here, or click to select files
                        to upload.
                      </div>
                    </Dropzone>
                  </div>
                </div>
                {this.state.poupupDamageError !== "" && (
                  <div className="row">
                    <div className="col-md-12" style={{ color: "red" }}>
                      {this.state.poupupDamageError}
                    </div>
                  </div>
                )}
                <div className="row">
                  {this.state.images.map((image, index) => (
                    <div className="col-md-6">
                      <div className="pincode-product-image">
                        <div className="pincode-product-image-img">
                          <img src={image.ImagePath} alt="Attachment" />
                        </div>
                        <div className="pincode-product-image-remove">
                          <a
                            onClick={() => this.onRemoveImage(index)}
                            className="btn btn-default btn-md pull-right"
                          >
                            <i className="fa fa-trash"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </Window>
        )}
      </>
    );
  }

  renderViewPoup() {
    return (
      <>
        {this.state.showViewPoup && (
          <Window
            header="Additional Info"
            width={"400px"}
            modal={true}
            onClose={() =>
              this.setState({
                showViewPoup: false,
                images: [],
                showViewPoup: false,
                damageReason: "",
                wrongProductValue: "",
              })
            }
            buttons={
              [
                // { Type: "secondary", Text: "Cancel", Align: "left" },
                // { Type: "primary", Text: "Save", Align: "right" },
              ]
            }
          >
            <div className="row">
              <div className="col-md-6">
                <Input
                  type="select"
                  value={this.state.damageReason}
                  label="Reason"
                  disabled={true}
                  onChange={(value) => {
                    this.setState({
                      damageReason: value,
                      wrongProductValue: "",
                    });
                  }}
                >
                  <option value="damaged">Damaged</option>
                  <option value="wrong product">Wrong product</option>
                  <option value="wrong barcode">Wrong barcode</option>
                  <option value="wrong mrp">Wrong MRP</option>
                </Input>
              </div>
            </div>
            {this.state.damageReason === "wrong barcode" && (
              <div className="row">
                <div className="col-md-6">
                  <Input
                    type="text"
                    label="Received product barcode"
                    disabled={true}
                    value={this.state.wrongProductValue}
                    error={this.state.wrongProductValueError}
                    onChange={(value) =>
                      this.setState({ wrongProductValue: value })
                    }
                  />
                </div>
              </div>
            )}
            <div className="row">
              {this.state.images.map((image) => (
                <div className="col-md-6">
                  <div className="pincode-product-image">
                    <div className="pincode-product-image-img">
                      <img src={image} alt="Attachment" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Window>
        )}
      </>
    );
  }

  renderPutAwayConfirmation() {
    if (!this.state.showPutAwayConfirmation) return null;

    const selectedCount = this.state.selectedItems.length;

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 2000,
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "5px",
            width: "400px",
            maxWidth: "calc(100vw - 24px)",
            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
          }}
        >
          <h4>Confirm Put Away</h4>
          <p>
            Are you sure you want to mark selected item as "Put away - Done"?
            This action cannot be undone.
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
              gap: "10px",
            }}
          >
            <button className="btn btn-default" onClick={this.cancelPutAway}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={this.confirmPutAway}>
              Confirm
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderApproveReject() {
    return (
      <>
        {this.state.showApproveRejectScreen && (
          <Window
            header={this.state.selectedItem.Name}
            width={"400px"}
            modal={true}
            onClose={() =>
              this.setState({
                showApproveRejectScreen: false,
                selectedItem: null,
                selectedItemIndex: -1,
              })
            }
            buttons={[
              { Type: "secondary", Text: "Cancel", Align: "left" },
              { Type: "primary", Text: "Save", Align: "right" },
            ]}
            onButtonClick={(buttonType) => {
              if (buttonType.toLowerCase() === "save") {
                let selectedItem = this.state.selectedItem;
                let damageRejectedQtyError = "";
                let damageRejectedQtyActionError = "";
                let shortRejectedQtyError = "";
                let shortRejectedQtyActionError = "";

                if (selectedItem.DamageQty > 0) {
                  let damageApprovedQty = selectedItem.DamageApprovedQty
                    ? Number(selectedItem.DamageApprovedQty)
                    : 0;
                  let damageRejectedQty = selectedItem.DamageRejectedQty
                    ? Number(selectedItem.DamageRejectedQty)
                    : 0;

                  if (damageApprovedQty === 0 && damageRejectedQty === 0) {
                    damageRejectedQtyError =
                      "Please specify damage rejected qty";
                  }
                  if (
                    damageRejectedQty > 0 &&
                    selectedItem.DamageRejectedQtyAction === ""
                  ) {
                    damageRejectedQtyActionError = "Please select option";
                  }
                }

                if (selectedItem.ShortQty > 0) {
                  let shortApprovedQty = selectedItem.ShortApprovedQty
                    ? Number(selectedItem.ShortApprovedQty)
                    : 0;
                  let shortRejectedQty = selectedItem.ShortRejectedQty
                    ? Number(selectedItem.ShortRejectedQty)
                    : 0;

                  if (shortApprovedQty === 0 && shortRejectedQty === 0) {
                    shortRejectedQtyError =
                      "Please specify damage rejected qty";
                  }
                  if (
                    shortRejectedQty > 0 &&
                    selectedItem.ShortRejectedQtyAction === ""
                  ) {
                    shortRejectedQtyActionError = "Please select option";
                  }
                }
                if (
                  damageRejectedQtyError !== "" ||
                  damageRejectedQtyActionError !== "" ||
                  shortRejectedQtyError !== "" ||
                  shortRejectedQtyActionError !== ""
                ) {
                  this.setState({
                    damageRejectedQtyError: damageRejectedQtyError,
                    damageRejectedQtyActionError: damageRejectedQtyActionError,
                    shortRejectedQtyError: shortRejectedQtyError,
                    shortRejectedQtyActionError: shortRejectedQtyActionError,
                  });
                  return;
                }
                //start saving
                this.saveLineItemApproveReject(selectedItem);
              } else {
                this.setState({
                  showApproveRejectScreen: false,
                  selectedItemIndex: -1,
                  selectedItem: null,
                });
              }
            }}
          >
            <>
              {this.state.selectedItem.DamageQty > 0 && (
                <>
                  <div className="row">
                    <div className="col-md-6">DAMAGED</div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <Input
                        type="number"
                        label="Damage Qty"
                        disabled={true}
                        value={this.state.selectedItem.DamageQty}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <Input
                        type="number"
                        label="Rejected Damage Qty"
                        onChange={(value) => {
                          let selectedItem = this.state.selectedItem;
                          if (value > selectedItem.DamageQty || value < 0) {
                            return;
                          }
                          selectedItem.DamageRejectedQty = value;
                          selectedItem.DamageApprovedQty =
                            selectedItem.DamageQty - value;
                          selectedItem.DamageRejectedQtyAction = "";
                          selectedItem.DamageRejectedQtyError = "";
                          this.setState({ selectedItem: selectedItem });
                        }}
                        value={this.state.selectedItem.DamageRejectedQty}
                        error={this.state.damageRejectedQtyError}
                      />
                    </div>
                  </div>
                  {Number(
                    this.state.selectedItem.DamageRejectedQty
                      ? this.state.selectedItem.DamageRejectedQty
                      : 0
                  ) > 0 && (
                    <>
                      <div className="row">
                        <div className="col-md-12">
                          <Input
                            type="select"
                            label="Rejected Damage Qty Action"
                            value={
                              this.state.selectedItem.DamageRejectedQtyAction
                            }
                            onChange={(value) => {
                              let selectedItem = this.state.selectedItem;
                              selectedItem.DamageRejectedQtyAction = value;
                              this.setState({
                                selectedItem: selectedItem,
                                damageRejectedQtyError: "",
                              });
                            }}
                            error={this.state.damageRejectedQtyActionError}
                          >
                            <option value={""}>Please select</option>
                            <option value={"DAMAGE_BY_MERCHANT"}>
                              Damage at Merchants end
                            </option>
                            <option value={"INWARD_BY_MERCHANT"}>
                              Not Damaged to be Inwarded by Merchant
                            </option>
                          </Input>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="row">
                    <div className="col-md-6">
                      <Input
                        type="number"
                        label="Approved Damage Qty"
                        disabled={true}
                        value={this.state.selectedItem.DamageApprovedQty}
                      />
                    </div>
                  </div>
                  {this.state.selectedItem.DamageApprovedQty > 0 && (
                    <div className="row">
                      <div className="col-md-6">
                        <Input
                          type="checkbox"
                          label="Approved Damage Qty to be returned to WH"
                          value={this.state.selectedItem.ReturnToWh}
                          onChange={(value) => {
                            let selectedItem = this.state.selectedItem;
                            selectedItem.ReturnToWh = value;
                            this.setState({ selectedItem: selectedItem });
                          }}
                        ></Input>
                      </div>
                    </div>
                  )}
                </>
              )}

              {this.state.selectedItem.ShortQty > 0 && (
                <>
                  <div className="row">
                    <div className="col-md-6">SHORT</div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <Input
                        type="number"
                        label="Short Qty"
                        disabled={true}
                        value={this.state.selectedItem.ShortQty}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <Input
                        type="number"
                        label="Rejected Short Qty"
                        onChange={(value) => {
                          let selectedItem = this.state.selectedItem;
                          if (value > selectedItem.ShortQty || value < 0) {
                            return;
                          }
                          selectedItem.ShortRejectedQty = value;
                          selectedItem.ShortApprovedQty =
                            selectedItem.ShortQty - value;
                          selectedItem.ShortRejectedQtyAction = "";
                          this.setState({
                            selectedItem: selectedItem,
                            shortRejectedQtyError: "",
                          });
                        }}
                        value={this.state.selectedItem.ShortRejectedQty}
                        error={this.state.shortRejectedQtyError}
                      />
                    </div>
                  </div>
                  {Number(
                    this.state.selectedItem.ShortRejectedQty
                      ? this.state.selectedItem.ShortRejectedQty
                      : 0
                  ) > 0 && (
                    <div className="row">
                      <div className="col-md-12">
                        <Input
                          type="select"
                          label="Rejected Short Qty Action"
                          value={this.state.selectedItem.ShortRejectedQtyAction}
                          onChange={(value) => {
                            let selectedItem = this.state.selectedItem;
                            selectedItem.ShortRejectedQtyAction = value;
                            selectedItem.ShortRejectedQtyActionError = "";
                            this.setState({ selectedItem: selectedItem });
                          }}
                          error={this.state.shortRejectedQtyActionError}
                        >
                          <option value={""}>Please select</option>
                          <option value={"SHORT_BY_MERCHANT"}>
                            Short at Merchants end
                          </option>
                          <option value={"INWARD_BY_MERCHANT"}>
                            Not Short to be Inwarded by Merchant
                          </option>
                        </Input>
                      </div>
                    </div>
                  )}
                  <div className="row">
                    <div className="col-md-6">
                      <Input
                        type="number"
                        label="Approved Short Qty"
                        disabled={true}
                        value={this.state.selectedItem.ShortApprovedQty}
                      />
                    </div>
                  </div>
                </>
              )}
            </>
          </Window>
        )}
      </>
    );
  }

  exportData = () => {
    const hasErrors = Object.keys(this.state.errorMessages).length > 0;
    if (hasErrors) {
      alert("Please fix all validation errors before exporting.");
      return;
    }
    const { transactionDetails } = this.state;
    const hidePutawayAndImport =
      transactionDetails && transactionDetails.Status === "Completed";

    const exportableItems = this.state.inTransitList;

    // If specific items are selected, filter those too
    const itemsToExport =
      this.state.selectedItems.length > 0
        ? exportableItems.filter((item) =>
            this.state.selectedItems.includes(item.key)
          )
        : exportableItems;

    if (itemsToExport.length === 0) {
      alert(
        "No exportable items found. All selected items are locked or no items match the criteria."
      );
      return;
    }

    const headers = [
      "WHSKU",
      "Product Name",
      "BarCode",
      "MRP",
      "Expiry",
      "Supply Price",
      "Shipped Qty",
      "Received Qty",
      "Damage Qty",
      "Short Qty",
      "Status",
      "GRNNo",
      "DNNO",
    ];

    const rows = exportableItems.map((item) => [
      item.GID,
      item.Name,
      item.BarCode,
      item.MRP,
      item.Expiry,
      item.SupplierPrice,
      item.InvoiceQty,
      item.InwardQty,
      item.DamageQty,
      item.ShortQty,
      //item.PackageDetails ? item.PackageDetails.map(pkg => `${pkg.PackageID}`).join(';') : '',
      // item.PackageID,
      item.Status,
      item.GRNNO ? item.GRNNO : "",
      item.DNNO ? item.DNNO : "",
    ]);

    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent += headers.join(",") + "\r\n";
    rows.forEach((rowArray) => {
      csvContent += rowArray.map((field) => `"${field}"`).join(",") + "\r\n";
    });

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "in_transit_products.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  handleImport = async (event) => {
    this.setState({
      errorMessages: {},
      showSaveErrors: false,
    });
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const content = e.target.result;
        const lines = content.split("\n");
        const headers = lines[0]
          .split(",")
          .map((h) => h.trim().replace(/"/g, ""));

        const importedData = [];
        const errors = {};
        let hasErrors = false;

        for (let i = 1; i < lines.length; i++) {
          if (lines[i].trim() === "") continue;

          const values = lines[i]
            .split(",")
            .map((v) => v.trim().replace(/"/g, ""));
          const item = {};
          const rowErrors = {};

          headers.forEach((header, index) => {
            const fieldMap = {
              "Product Name": "Name",
              Image: "Image",
              SKU: "SKU",
              Barcode: "BarCode",
              // "MRP": "MRP",
              "Supplier Price": "SupplierPrice",
              "Invoice Qty": "InvoiceQty",
              // "Inward Qty": "InwardQty",
              "Received Qty": "InwardQty",
              "Damage/Wrong Qty": "DamageQty",
              "Short Qty": "ShortQty",
              Status: "Status",
              Packages: "PackageID",
              GID: "GID",
            };

            if (fieldMap[header]) {
              item[fieldMap[header]] = values[index];
            }
          });

          // Validate quantities
          if (item.InvoiceQty !== undefined) {
            item.InvoiceQty = parseInt(item.InvoiceQty) || 0;
            item.InwardQty = parseInt(item.InwardQty) || 0;
            item.DamageQty = parseInt(item.DamageQty) || 0;
            item.ShortQty = parseInt(item.ShortQty) || 0;

            const total = item.InwardQty + item.DamageQty + item.ShortQty;
            //const total = item.InwardQty + item.ShortQty;
            if (total > item.InvoiceQty) {
              rowErrors.quantities = `Total quantities (${total}) cannot exceed Invoice Qty (${item.InvoiceQty})`;
              hasErrors = true;
            }
          }

          // Handle "Not received" status
          if (item.Status === "Not received") {
            item.InwardQty = 0;
            item.ShortQty = item.InvoiceQty;
            item.DamageQty = 0;
          }

          if (Object.keys(item).length > 0) {
            item.key = Math.random()
              .toString(36)
              .substr(2, 9);
            importedData.push(item);
          }

          if (Object.keys(rowErrors).length > 0) {
            errors[i] = rowErrors;
          }
        }

        if (hasErrors) {
          this.setState({
            errorMessages: errors,
            showSaveErrors: true,
          });
          return;
        }

        // Prepare FormData for upload
        const formData = new FormData();
        formData.append("file", file);
        formData.append("userId", this.state.userId);
        formData.append("registrationID", this.props.user.user.RegistrationID);
        formData.append("storeID", this.props.user.store.key);

        // Upload to server
        const { key } = this.props.match.params;
        const response = await axios.post(
          `${BaseURL}/v1/vendorstockinward/${key}/fileupload`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.code == 0) {
          this.setState({
            inTransitList: response.data.data.Lineitems.map((item) => ({
              key: item._id,
              Name: item.ProductName,
              SKU: item.SKU,
              BarCode: item.Barcode,
              Image:
                item.Images && item.Images.length > 0 ? item.Images[0] : "",
              MRP: item.MRP,
              SupplierPrice: item.SupplyPrice,
              InvoiceQty: item.InvoiceQty,
              InwardQty:
                item.Status === "Not Received" ? 0 : item.InwardQty || 0,
              DamageQty: item.DamagedQty || 0,
              ShortQty:
                item.Status === "Not Received"
                  ? item.InvoiceQty
                  : item.ShortQty || 0,
              GID: item.GID,
              PackageDetails: item.PackageDetails || [],
              PackageID: item.PackageID || "",
              Status: item.Status || "Not Received",
              ShortApprovedQty: item.ShortApprovedQty
                ? item.ShortApprovedQty
                : 0,
              ShortRejectedQty: item.ShortRejectedQty
                ? item.ShortRejectedQty
                : 0,
              ShortRejectionReason: item.ShortRejectionReason
                ? item.ShortRejectionReason
                : "",

              DamageApprovedQty: item.DamageApprovedQty
                ? item.DamageApprovedQty
                : "",
              DamageRejectedQty: item.DamageRejectedQty
                ? item.DamageRejectedQty
                : "",
              DamageRejectionReason: item.DamageRejectionReason
                ? item.DamageRejectionReason
                : "",
              VerificationStatus: item.ApprovalStatus,
              ReturnToWh: item.ReturnToWh,
              _id: item._id,
            })),
            transactionDetails: response.data.data,
            saved: true,
          });
          setTimeout(() => this.setState({ saved: false }), 3000);
        } else {
          throw new Error(response.data.message || "Import failed");
        }
      } catch (error) {
        console.error("Import error:", error);
        alert(`Import failed: ${error.message}`);
      }
    };

    reader.readAsText(file);
  };

  render() {
    if (this.state.loading) {
      return <div>Loading in-transit data...</div>;
    }

    return (
      <React.Fragment>
        <Page
          hideHeader={true}
          title={""}
          onClick={(action) => {
            // Handle page actions if needed
          }}
        >
          {this.state.inTransitList && (
            <React.Fragment>
              <PageSection>
                <div className="row">
                  <div className="col-md-12">
                    {this.renderTransactionDetails()}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">{this.renderItems()}</div>
                </div>
              </PageSection>
              {this.renderFooter()}
              {this.renderPutAwayConfirmation()}
              {this.renderApproveReject()}
            </React.Fragment>
          )}
        </Page>
        {this.renderPoup()}
        {this.renderViewPoup()}
      </React.Fragment>
    );
  }
}

export default InTransit;
